import React, {useCallback, useState, useContext, useEffect} from 'react';
import {Popup, Input, Checkbox, Button, setOptions, toast, confirm as mbConfirm, SegmentedGroup, Segmented, Select} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/dashboardHeaderAccountUser.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";
import Empty from "../utils/Empty";
import Loading from "../utils/Loading";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeaderAccountUser({locale, dialog, Dialog, userData, width, configuration}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [admin, setAdmin] = useState(!Empty(userData) ? userData.options.admin : false);
    const [firstName, setFirstName] = useState(!Empty(userData) ? userData.firstName : null);
    const [lastName, setLastName] = useState(!Empty(userData) ? userData.lastName : null);
    const [mobile, setMobile] = useState((!Empty(userData) && userData.mobile) ? userData.mobile : null);
    const [email, setEmail] = useState((!Empty(userData) && userData.email) ? userData.email : null);
    const [country, setCountry] = useState(() => {
        if ((!Empty(userData) && userData.type === 'mobile' &&
                userData.id.startsWith('+1')) ||
            (!Empty(userData) && userData.type !== 'mobile' &&
                userData.mobile &&
                userData.mobile.startsWith('+1'))) {
            return 'us';
        } else if ((!Empty(userData) && userData.type === 'mobile' &&
                userData.id.startsWith('+52')) ||
            (!Empty(userData) && userData.type !== 'mobile' &&
                userData.mobile &&
                userData.mobile.startsWith('+52'))) {
            return 'mx';
        } else if ((!Empty(userData) && userData.type === 'mobile' &&
                userData.id.startsWith('+34')) ||
            (!Empty(userData) && userData.type !== 'mobile' &&
                userData.mobile &&
                userData.mobile.startsWith('+34'))) {
            return 'es';
        } else {
            return 'us';
        }
    });
    const [password, setPassword] = useState(null);
    const [confirm, setConfirm] = useState(null);
    const [type, setType] = useState(configuration.ui.login.mobile ? 'mobile' : 'email');
    const [saving, setSaving] = useState(null);

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const ItemSave = () => {
        setSaving(true);

        const message = {
            type: 'wss',
            path: 'account-user',
            action: Empty(userData) ? 'put' : 'update',
            data: {
                userData: !Empty(userData) ? userData : null,
                type: Empty(userData) ? type : null,
                mobile: (Empty(userData) && mobile) ? mobile.replace(/[()\s-]/g, '') : null,
                email: (Empty(userData) && email) ? email : null,
                country: Empty(userData) ? country: null
            }
        }
        if (password) {
            message.data.password = password;
        }
        if ((Empty(userData) && firstName) || (!Empty(userData) && firstName !== userData.firstName)) {
            message.data.firstName = firstName;
        }
        if ((Empty(userData) && lastName) || (!Empty(userData) && lastName !== userData.lastName)) {
            message.data.lastName = lastName;
        }
        if (Empty(userData) || (!Empty(userData) && admin !== userData.options.admin)) {
            message.data.admin = admin;
        }
        wsCall(message);
    }

    const SegmentedType = data => {
        setType(data.target.value);
    }

    const SelectUpdate = data => {
        setCountry(data);
    }

    const InputMobile = data => {
        let formattedText = '';

        if (country === 'us') {
            const cleanedText = data.replace(/[^\d]/g, '');

            if (cleanedText.length <= 3) {
                formattedText = cleanedText;
            } else if (cleanedText.length <= 6) {
                formattedText = `(${cleanedText.slice(0, 3)}) ${cleanedText.slice(3)}`;
            } else {
                formattedText = `(${cleanedText.slice(0, 3)}) ${cleanedText.slice(3, 6)}-${cleanedText.slice(6, 10)}`;
            }
        } else if (country === 'mx') {
            const cleanedText = data.replace(/[^\d]/g, '');

            if (cleanedText.length <= 2) {
                formattedText = cleanedText;
            } else if (cleanedText.length <= 6) {
                formattedText = `(${cleanedText.slice(0, 2)}) ${cleanedText.slice(2)}`;
            } else {
                formattedText = `(${cleanedText.slice(0, 2)}) ${cleanedText.slice(2, 6)}-${cleanedText.slice(6, 10)}`;
            }
        } else if (country === 'es') {
            const cleanedText = data.replace(/[^\d]/g, '');

            if (cleanedText.length <= 3) {
                formattedText = cleanedText;
            } else if (cleanedText.length <= 5) {
                formattedText = `${cleanedText.slice(0, 3)} ${cleanedText.slice(3)}`;
            } else if (cleanedText.length <= 7) {
                formattedText = `${cleanedText.slice(0, 3)} ${cleanedText.slice(3, 5)} ${cleanedText.slice(5)}`;
            } else {
                formattedText = `${cleanedText.slice(0, 3)} ${cleanedText.slice(3, 5)} ${cleanedText.slice(5, 7)} ${cleanedText.slice(7, 9)}`;
            }
        }
        setMobile(formattedText);
    }

    const ButtonClose = () => {
        if (!Empty(userData) &&
            ((password && !confirm) ||
                (confirm && !password) ||
                (password && confirm && password !== confirm))) {
            toast({message: locale.dashboardHeaderAccountUser.j, color: 'danger', display: 'bottom', duration: 3000});
        } else if (!Empty(userData) &&
            (password ||
            admin !== userData.options.admin ||
            firstName !== userData.firstName ||
            lastName !== userData.lastName)) {
            ItemSave();
        } else {
            Dialog({view: 'dashboardHeaderAccount'});
        }
    }

    const ButtonCreate = () => {
        if (!(firstName || lastName)) {
            toast({message: locale.dashboardHeaderAccountUser.r, color: 'danger', display: 'bottom', duration: 3000});
        } else if (!((type === 'email' && email) || (type === 'mobile' && mobile))) {
            toast({message: locale.dashboardHeaderAccountUser.s, color: 'danger', display: 'bottom', duration: 3000});
        } else if ((password && !confirm) || (confirm && !password) || (password && confirm && password !== confirm)) {
            toast({message: locale.dashboardHeaderAccountUser.j, color: 'danger', display: 'bottom', duration: 3000});
        } else if ((firstName || lastName) && ((type === 'email' && email) || (type === 'mobile' && mobile))) {
            ItemSave();
        }
    }

    const ButtonDelete = () => {
        mbConfirm({
            title: locale.dashboardHeaderAccountUser.l,
            message: locale.dashboardHeaderAccountUser.m,
            okText: locale.dashboardHeaderAccountUser.n,
            cancelText: locale.dashboardHeaderAccountUser.o,
            callback: (res) => {
                if (res) {
                    setSaving(true);

                    const message = {
                        type: 'wss',
                        path: 'account-user',
                        action: 'delete',
                        data: {
                            userData: userData
                        }
                    };
                    wsCall(message);
                }
            }
        });
    }

    const UserMobile = data => {
        let formattedText = '';
        const cleanedText = data.replace(/[^\d]/g, '');

        if (country === 'us') {
            const digits = cleanedText.startsWith('1') ? cleanedText.slice(1) : cleanedText;

            if (digits.length <= 3) {
                formattedText = digits;
            } else if (digits.length <= 6) {
                formattedText = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
            } else {
                formattedText = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
            }
        } else if (country === 'mx') {
            const digits = cleanedText.startsWith('52') ? cleanedText.slice(2) : cleanedText;

            if (digits.length <= 2) {
                formattedText = digits;
            } else if (digits.length <= 6) {
                formattedText = `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
            } else {
                formattedText = `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6, 10)}`;
            }
        } else if (country === 'es') {
            const cleanedText = data.replace(/[^\d]/g, '');

            if (cleanedText.length <= 3) {
                formattedText = cleanedText;
            } else if (cleanedText.length <= 5) {
                formattedText = `${cleanedText.slice(0, 3)} ${cleanedText.slice(3)}`;
            } else if (cleanedText.length <= 7) {
                formattedText = `${cleanedText.slice(0, 3)} ${cleanedText.slice(3, 5)} ${cleanedText.slice(5)}`;
            } else {
                formattedText = `${cleanedText.slice(0, 3)} ${cleanedText.slice(3, 5)} ${cleanedText.slice(5, 7)} ${cleanedText.slice(7, 9)}`;
            }
        }

        return formattedText;
    }

    const HeaderUser = () => {
        if (!Empty(userData) && userData.type === 'mobile') {
            return UserMobile(userData.id);
        } else if (!Empty(userData)) {
            return userData.id;
        } else if (Empty(userData)) {
            return locale.dashboardHeaderAccountUser.p;
        }
    }

    const DeleteAccountUser = useCallback(data => {
        if (data.toast) {
            Dialog({view: 'dashboardHeaderAccount'});
        }
        if (data.error && data.stripe) {
            toast({message: locale.dashboardHeaderAccountUser.w, color: 'danger', display: 'bottom', duration: 3000});
            setSaving(false);
        }
    }, [Dialog, locale.dashboardHeaderAccountUser.w]);

    const UpdateAccountUser = useCallback(data => {
        if (data.toast) {
            Dialog({view: 'dashboardHeaderAccount'});
        }
    }, [Dialog]);

    const PutAccountUser = useCallback(data => {
        if (data.toast) {
            Dialog({view: 'dashboardHeaderAccount'});
        }
        if (data.error && data.user) {
            toast({message: locale.dashboardHeaderAccountUser.g, color: 'danger', display: 'bottom', duration: 3000});
            setSaving(false);
        }
        if (data.error && data.stripe) {
            toast({message: locale.dashboardHeaderAccountUser.g, color: 'danger', display: 'bottom', duration: 3000});
            setSaving(false);
        }
    }, [Dialog, locale.dashboardHeaderAccountUser.g]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'put' && wsResponse.path === 'account-user') {
            PutAccountUser(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, PutAccountUser, setWsResponse]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'delete' && wsResponse.path === 'account-user') {
            DeleteAccountUser(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, DeleteAccountUser, setWsResponse]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'account-user') {
            UpdateAccountUser(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateAccountUser, setWsResponse]);

    return (
        <Popup className="cs-dashboard-header-account-user-popup" width={600} display="center" scrollLock={true} closeOnOverlayClick={false} closeOnEsc={false} buttons={[]} isOpen={dialog.view === 'dashboardHeaderAccountUser'} onClose={DialogClose}>
            <div className="mbsc-grid cs-dashboard-header-account-user-header-col">
                <div className="mbsc-row cs-dashboard-header-account-user-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-dashboard-header-account-user-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-dashboard-header-account-user-header-col mbsc-align-center" : "mbsc-col cs-dashboard-header-account-user-header-col"} >
                        <Button className="cs-dashboard-header-account-user-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                            {HeaderUser()}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-dashboard-header-account-user-header-col mbsc-align-right">
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-account-user-close-button" onClick={() => ButtonClose()} >
                            &nbsp;<FontAwesomeIcon className="cs-dashboard-header-account-user-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            {!Empty(userData) && userData.avatar &&
                <div className="mbsc-grid cs-dashboard-header-account-user-header-col">
                    <div className="mbsc-row cs-dashboard-header-account-user-header-row mbsc-justify-content-center">
                        <div style={{backgroundImage: "url(https://www.gravatar.com/avatar/" + userData.avatar + "?d=robohash)"}} className="cs-dashboard-header-account-user-avatar" />
                    </div>
                </div>
            }
            <Input inputStyle="underline" label={locale.dashboardHeaderAccountUser.a} labelStyle="floating" type="text" name="firstName" value={firstName} onChange={ev => setFirstName(ev.target.value)}/>
            <Input inputStyle="underline" label={locale.dashboardHeaderAccountUser.b} labelStyle="floating" type="text" name="lastName" value={lastName} onChange={ev => setLastName(ev.target.value)}/>
            {Empty(userData) && configuration.ui.login.multiple &&
                <div className="mbsc-grid cs-dashboard-header-account-user-header-col">
                    <div className="mbsc-row cs-dashboard-header-account-user-header-row">
                        <SegmentedGroup className="cs-dashboard-header-account-user-nav" name="login" color="primary" value={type} onChange={SegmentedType}>
                            {configuration.ui.login.email &&
                                <Segmented value="email" >
                                    {locale.login.o}
                                </Segmented>
                            }
                            {configuration.ui.login.mobile &&
                                <Segmented value="mobile" >
                                    {locale.login.b}
                                </Segmented>
                            }
                        </SegmentedGroup>
                    </div>
                </div>
            }
            {((!Empty(userData) && userData.type !== 'mobile' && mobile) || (Empty(userData) && type === 'mobile')) &&
                <div className="mbsc-grid cs-dashboard-header-account-user-header-col">
                    <div className="mbsc-row">
                        <div className="mbsc-col-4 cs-dashboard-header-account-user-inputs-left">
                            <Select
                                animation="slide-down"
                                dropdown={false}
                                inputStyle="underline"
                                label={locale.dashboardHeaderAccountUser.t}
                                labelStyle="floating"
                                rows={locale.dashboardHeaderAccountUser.u.length}
                                display="anchored"
                                touchUi={false}
                                value={country}
                                data={locale.dashboardHeaderAccountUser.u}
                                disabled={(Empty(userData) && mobile && mobile.length !== 0) || !Empty(userData)}
                                onChange={args => SelectUpdate(args.value)}
                            />
                        </div>
                        <div className="mbsc-col-8 cs-dashboard-header-account-user-inputs-right">
                            <Input
                                disabled={!Empty(userData)}
                                className="cs-dashboard-header-account-user-inputs-right-input"
                                label={locale.dashboardHeaderAccountUser.f}
                                inputStyle="underline"
                                labelStyle="floating"
                                type="text"
                                name="mobile"
                                value={mobile}
                                onChange={ev => InputMobile(ev.target.value)}
                            />
                        </div>
                    </div>
                </div>
            }
            {((!Empty(userData) && userData.type !== 'email' && email) || (Empty(userData) && type === 'email')) &&
                <Input disabled={!Empty(userData)} inputStyle="underline" label={locale.dashboardHeaderAccountUser.d} labelStyle="floating" type="text" name="email" value={email} onChange={ev => setEmail(ev.target.value)} />
            }
            <Input inputStyle="underline" label={locale.dashboardHeaderAccountUser.h} labelStyle="floating" type="password" name="password" passwordToggle={true} value={password} onChange={(ev) => setPassword(ev.target.value)} />
            <Input inputStyle="underline" label={locale.dashboardHeaderAccountUser.i} labelStyle="floating" type="password" name="confirm" passwordToggle={true} value={confirm} onChange={(ev) => setConfirm(ev.target.value)} />
            {saving &&
                <Loading />
            }
            {!saving &&
                <Checkbox
                    cssClass="cs-dashboard-header-account-user-checkbox mbsc-bold"
                    color="info"
                    label={locale.dashboardHeaderAccountUser.c}
                    checked={admin}
                    position="start"
                    onChange={ev => setAdmin(ev.target.checked)}
                />
            }
            {!saving &&
                <div className="mbsc-button-group-justified cs-dashboard-header-account-user-nav-buttons">
                    {Empty(userData) &&
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-account-user-nav-button" onClick={() => ButtonCreate()} >
                            {locale.dashboardHeaderAccountUser.q}
                        </Button>
                    }
                    {!Empty(userData) &&
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-account-user-nav-button" onClick={() => ButtonDelete()} >
                            {locale.dashboardHeaderAccountUser.e}
                        </Button>
                    }
                </div>
            }
        </Popup>
    );
}

export default DashboardHeaderAccountUser;
